var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPolarfiText(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 25,
    viewBox: "0 0 97 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 80"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 79"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.7364 9.30007C16.7364 13.6628 13.3985 17.1728 9.09463 17.1728H5.81876V24.3885H0.828003V1.42371H9.09807C13.3985 1.42371 16.7364 4.93371 16.7364 9.30007ZM11.7456 9.30007C11.7456 7.6272 10.6223 6.34809 9.09463 6.34809H5.81876V12.252H9.09463C10.6223 12.2484 11.7456 10.9693 11.7456 9.30007Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.3616 16.1847C17.3616 11.2965 21.0372 7.52441 25.6316 7.52441C30.2261 7.52441 33.9017 11.2965 33.9017 16.1847C33.9017 21.0728 30.2261 24.8449 25.6316 24.8449C21.0372 24.8449 17.3616 21.0716 17.3616 16.1847ZM29.2153 16.1847C29.2153 13.8559 27.6555 12.3196 25.627 12.3196C23.5986 12.3196 22.0399 13.862 22.0399 16.1847C22.0399 18.5074 23.5997 20.0498 25.627 20.0498C27.6544 20.0498 29.2153 18.5134 29.2153 16.1847Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M36.546 0.439331H41.2255V24.3849H36.546V0.439331Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M60.659 7.9834V24.3847H55.9795V22.8435C54.9457 24.09 53.4215 24.8449 51.3322 24.8449C47.2454 24.8449 43.8765 21.0716 43.8765 16.1847C43.8765 11.2977 47.2454 7.52441 51.3322 7.52441C53.4215 7.52441 54.9503 8.27932 55.9795 9.52582V7.9834H60.659ZM55.9795 16.1847C55.9795 13.7243 54.4208 12.1831 52.2683 12.1831C50.1158 12.1831 48.5559 13.7243 48.5559 16.1847C48.5559 18.6451 50.1158 20.1863 52.2683 20.1863C54.4208 20.1863 55.9795 18.6451 55.9795 16.1847Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M73.4484 7.6561V13.2327C71.5141 12.9042 68.7689 13.7243 68.7689 16.977V24.3896H64.0906V7.98342H68.7689V10.9028C69.388 8.70572 71.4831 7.6561 73.4484 7.6561Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M91.3855 3.58802C91.3855 3.00443 91.55 2.43394 91.8582 1.94862C92.1664 1.4633 92.6045 1.08493 93.1171 0.861329C93.6297 0.637724 94.1939 0.578917 94.7383 0.692331C95.2827 0.805745 95.7829 1.08629 96.1757 1.49853C96.5685 1.91077 96.8364 2.43619 96.9453 3.00842C97.0543 3.58065 96.9995 4.17401 96.7879 4.71351C96.5763 5.25302 96.2174 5.71447 95.7565 6.03956C95.2956 6.36466 94.7534 6.5388 94.1985 6.53999C93.4553 6.5337 92.7441 6.22086 92.218 5.66879C91.692 5.11671 91.393 4.36953 91.3855 3.58802ZM91.853 7.98337H96.5325V24.3847H91.853V7.98337Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M80.7795 6.47492V10.9029H88.8899V15.9553H80.7795V24.3849H75.7887V1.42371H89.0461V6.47492H80.7795Z",
    fill: "#ECECEC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolarfiText);
export default __webpack_public_path__ + "static/media/polarfi-text.9387943ff43b081d92ab7489fcd2185a.svg";
export { ForwardRef as ReactComponent };